import configurations from '@/config';
import { computed } from 'vue';
import { useEnvironment } from './environment';

export const useConfig = () => {
  const environment = useEnvironment();

  return computed(() => {
    return configurations[environment.value];
  });
};
